import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import RouterConstants from "../../../constants/RouterConstants";
import useSecureNavigate from "../../../hooks/useSecureNavigate";
import { useAppStore } from "../../../hooks/useStores";

const AdsGenerationBrandsTemplates = () => {
	const navigate = useSecureNavigate();
	const { uiStore } = useAppStore();
	const { t } = useTranslation("translation", { keyPrefix: "editor" });

	useEffect(() => {
		uiStore.showBackButton(
			RouterConstants.ADS_GENERATION.OVERVIEW.fullPath,
			undefined,
			t("backToAdsGenerationHub"),
		);
		navigate(RouterConstants.ADS_GENERATION.DEMO.BRANDS_TEMPLATES_EDITOR.fullPath);
	}, []);

	return null;
};

export default observer(AdsGenerationBrandsTemplates);
